import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import ControlledInputText from 'components/common/forms/controlled_input_text';
import { useCheckoutFlow } from 'components/context/checkout_flow';
import ControlledInputSelect from 'components/common/forms/controlled_input_select';
import { POSTAL_CODE_REGEX_BY_COUNTRY } from 'constants/patterns';
import { JP_PREFECTURE_MAPPINGS } from 'constants/mappings';

const AddressFields = (props) => {
  const { t } = useTranslation();
  const { control, watch, setValue } = useFormContext();
  const { addressClient } = useCheckoutFlow();

  const { address, countryCode, namePrefix = '' } = props;

  const autocompleteFromPostalCode = (postalCode) => {
    addressClient
      .jpPostalCodeLookup(postalCode)
      .then(
        (data) =>
          data['administrative_district_level_1'] &&
          setValue(
            `${namePrefix}administrative_district_level_1`,
            JP_PREFECTURE_MAPPINGS[data['administrative_district_level_1']],
          ),
      )
      .catch(); // empty catch because it's not the end of the world if there is no autocomplete
  };

  useEffect(() => {
    const subscription = watch((value, { name, type }) => {
      if (
        name === `${namePrefix}postal_code` &&
        type === 'change' &&
        POSTAL_CODE_REGEX_BY_COUNTRY.JP.test(value[`${namePrefix}postal_code`])
      ) {
        autocompleteFromPostalCode(value[`${namePrefix}postal_code`]);
      }
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  return (
    <>
      <Grid item xs={12} md={4}>
        <ControlledInputText
          name={`${namePrefix}postal_code`}
          control={control}
          defaultValue={address.postal_code}
          maxlength={8}
          rules={{
            required: true,
            maxLength: 8,
            pattern: {
              value: POSTAL_CODE_REGEX_BY_COUNTRY[countryCode],
              message: t('error.validation.invalidPostalCode'),
            },
          }}
          label={t('checkout.label.postalCode')}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <ControlledInputSelect
          name={`${namePrefix}administrative_district_level_1`}
          control={control}
          defaultValue={
            JP_PREFECTURE_MAPPINGS[address.administrative_district_level_1]
          }
          rules={{ required: true }}
          options={Object.entries(JP_PREFECTURE_MAPPINGS).map(([a, b]) => {
            return { value: b, displayValue: a };
          })}
          label={t('checkout.label.state')}
          shouldMaskValues={true}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <ControlledInputText
          name={`${namePrefix}locality`}
          control={control}
          defaultValue={address.sublocality_1 || address.locality}
          rules={{ required: true }}
          label={t('checkout.label.city')}
        />
      </Grid>
      <Grid item xs={12} md={12}>
        <ControlledInputText
          name={`${namePrefix}address_line_1`}
          control={control}
          defaultValue={address.address_line_1}
          maxlength={40}
          rules={{
            required: true,
            maxLength: 40,
          }}
          label={t('checkout.label.addressLine1')}
        />
      </Grid>
    </>
  );
};

export default AddressFields;
